import styled from 'styled-components';
import { mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  margin-bottom: var(--space-400);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-300);

  ${mediaQueries.mobileM} {
    margin-left: var(--space-n50);
  }
`;
